export const FILTER_OPTIONS = [
  "all",
  "news",
  "whitepaper",
  "glossar",
  "webinare-podcasts",
] as const;

export const EVENT_FILTER_OPTIONS = ["all", "webinar", "in-person"] as const;

export const SORT_OPTIONS = ["newest", "oldest"] as const;

export const COUNTRIES = [
  {
    name: "Germany",
    code: "DE",
    offices: ["Munich"],
  },
  {
    name: "Poland",
    code: "PL",
    offices: ["Warsaw"],
  },
  {
    name: "Italy",
    code: "IT",
    offices: ["Milan"],
  },
  {
    name: "Spain",
    code: "ES",
    offices: ["Madrid"],
  },
] as const;

export type KnowledgeType =
  "news" | "whitepaper" | "glossar" | "webinare-podcasts";

export type EventType = "webinar" | "in-person";

export type SortOrder = "newest" | "oldest";

export type FilterOption = (typeof FILTER_OPTIONS)[number];
export type EventFilterOption = (typeof EVENT_FILTER_OPTIONS)[number];
export type SortOption = (typeof SORT_OPTIONS)[number];
